<template>
  <section id="partsbase_market">
    <div class="title_div">
      <span class="site">PartsBase Market</span>
      <span v-if="pricing.medianUnitPrice" class='median' :title="'Median updated: '+ median_last_updated">Median {{numeral(pricing.medianUnitPrice).format('$0,0,0,0,0,0.00')}}</span>
    </div>
    <div class="plotly_figure" ref='plotly_figure'>
      
    </div>
  </section>
</template>

<style scoped>
  .title_div{
    margin-top: 1.5em;
    font-size: 2em;
  }
  .site{
    
  }
  .median{
    margin-left:1em;
    color: #3273dc;
  }
</style>

<script>
import Plotly from 'plotly.js/dist/plotly';
// var numeral = require('numeral');

export default {
  name: 'PlotPartsBase',
  components: {
  
  },
  props: [
    'plot_data',
    'pricing',
    // 'key', # Used to rerender
  ],
  data: function(){
    return {
      numeral: require('numeral'),
      layout: {
        // title:'PartsBase Market',
        legend: {
          x: 0,
          y: 1.3
        },
        yaxis: {
          title: {
                  text: 'Demand',
                  font: {
                    size: 18,
                    color: '#1f77b4'
                  }
                },
          rangemode: 'tozero',
          },
        yaxis2: {
          title: {
                  text: 'Supply',
                  font: {
                    size: 18,
                    color: '#ff7f0e'
                  }
                },
          rangemode: 'tozero',
          overlaying: 'y',
          side: 'right'
        }
      },
      options : {
        displayModeBar: false,
        responsive: true
      },
    };
  },
  computed:{
    median_last_updated() {
      let pricing = this.pricing;
      if (pricing && Object.prototype.hasOwnProperty.call(pricing, 'lastUpdated')) {
        return pricing.lastUpdated.split('T')[0];
      }
      return '';
    }
  },
  created: function(){
    
  },
  mounted: function(){ 
    Plotly.newPlot(this.$refs['plotly_figure'], this.plot_data, this.layout, this.options);
  },
  // watch: {
  //   plot_data: {
  //     handler: function() {
  //       Plotly.react(
  //         this.$refs['plotly_figure'],
  //         this.plot_data,
  //         this.layout, 
  //         this.options
  //       );
  //     },
  //     deep: true
  //   }
  // },
  methods: {

  }
};

</script>
